import { Component, Input } from '@angular/core';

@Component({
  selector: 'side-by-side-card',
  styleUrls: ['./side-by-side-card.css'],
  template: `
<div class="aboutTopic">
  <div class="left-column">
  <dynamic-heading [title]="title" [level]="titleSize"/>
  </div>
  <div class="right-column">
    <dynamic-heading *ngIf="description" [description]="description"/>
  </div>
</div>
  `
})
export class SideBySideCardComponent {
  @Input() title: string = 'About Us';
  @Input() description: string = 'We are not just a weather solutions provider; we’re an insights leader, transforming complex data into intelligence that drives success.';
  @Input() titleSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h3';
}
